import { render } from "./LandingPageForm.vue?vue&type=template&id=71f8f5a6&scoped=true"
import script from "./LandingPageForm.vue?vue&type=script&lang=js"
export * from "./LandingPageForm.vue?vue&type=script&lang=js"

import "./LandingPageForm.vue?vue&type=style&index=0&id=71f8f5a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f8f5a6"]])

export default __exports__